import OrganizationWaitingTimePerService from "../../../components/organization/reports/daily/OrganizationWaitingTimePerService";
import DailyGeneratedReportPage from "../../../components/reports/DailyGeneratedReportPage";
import { REPORT_TYPE_IDS } from "../../../store/constants";
import { WAITING_TIME_PER_SERVICE_COLUMN_DEFINITIONS } from "../../../store/renderConfig";

const DailyOrganizationWaitingTimePerService = ({ showFilterForm = true, showTitle = 1 }) => (
  <DailyGeneratedReportPage
    reportTypeId={REPORT_TYPE_IDS.daily_organization_waiting_time_per_service}
    title="Waiting Time Per Service"
    helmetTitle="Daily Organization Waiting Time Per Service"
    descriptionKey="WaitingTimePerService"
    columnDefinitions={WAITING_TIME_PER_SERVICE_COLUMN_DEFINITIONS}
    defaultSortColumn="completed"
    showFilterForm={showFilterForm}
    showTitle={showTitle}
  >
    {({ data, renderConfig, onRenderConfigChange }) => (
      <OrganizationWaitingTimePerService
        data={data}
        renderConfig={renderConfig}
        onRenderConfigChange={onRenderConfigChange}
      />
    )}
  </DailyGeneratedReportPage>
);

export default DailyOrganizationWaitingTimePerService;
